import React, { useEffect, useMemo, useState } from "react";

import "./core.scss";

import CoreLogo from "../../assets/images/wealth-series/core-signup.png";
import { Button } from "@mui/material";
import { Modal } from "@material-ui/core";
import ContactForm from "../EmeraldSignup/ContactForm";
import { useAuth } from "../../contexts/Auth";
import { connect } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router-dom";
import BeautifulSkeleton from "../common/Skeletons/BeautifulSkeleton";

const WealthSeriesCoreSignup = ({ userSettings }) => {
  const [open, setOpen] = useState(false);
  const { hasWealthSeriesCore, loading } = useAuth();
  const history = useHistory();
  const handleClose = () => setOpen(false);

  // Within 1 week of last submit → show disabled state "Access Requested"
  const hasSubmitted = useMemo(() => {
    const submitDate = userSettings?.wealthSeriesCoreContact;
    const weekSinceSubmit = moment(submitDate).add(1, "week");
    const today = moment();
    return submitDate ? today.isBefore(weekSinceSubmit) : false;
  }, [userSettings, loading]);

  // If user already has access, redirect to Core overview
  useEffect(() => {
    if (loading) return;
    if (hasWealthSeriesCore) {
      history.push("/wealth-series/core");
    }
  }, [loading, hasWealthSeriesCore]);

  useEffect(() => {
    if (loading) return;
    if (hasWealthSeriesCore) {
      history.push("/wealth-series/core");
    }
  }, [loading, hasWealthSeriesCore]);

  return (
    <div className="ws-core-signup">
      <div className="ws-core-signup-content">
        <img src={CoreLogo} alt="Core Logo" className="ws-core-signup-logo" />
        <div className="ws-core-info">
          <div className="ws-core-info-text-title">
            Smart trading made accessible
          </div>
          <div className="ws-core-info-text-description">
            Elevated trading with exclusive tools and insights, powered by AI.
          </div>
        </div>

        {loading ? (
          <BeautifulSkeleton width={570} height={42} />
        ) : (
          <Button
            variant="contained"
            color="primary"
            className="ws-core-signup-button"
            onClick={() => setOpen(true)}
            disabled={hasSubmitted}
          >
            {hasSubmitted ? "Access Requested" : "Contact us for Pricing"}
          </Button>
        )}

        <Modal open={open}>
          <ContactForm
            product_type="WEALTH SERIES CORE"
            onClose={handleClose}
          />
        </Modal>
      </div>
    </div>
  );
};

const stateToProps = (state) => ({
  userSettings: state.userSettings.userSettings,
});

export default connect(stateToProps)(WealthSeriesCoreSignup);
